import { api } from "../lib/api";

export const login = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);

export const register = (payload) =>
  api.post("/auth/register", payload).then((r) => r.data);

export const me = () => api.get("/auth/me").then((r) => r.data);

export const logout = () => api.post("/auth/logout").then((r) => r.data);

export const forgotPassword = (email) =>
  api.post("/auth/forgot-password", { email }).then((r) => r.data);

export const resetPassword = ({ token, password, new_password }) =>
  api.post("/auth/reset-password", {
    token,
    password: password || new_password,
    new_password: new_password || password,
  }).then((r) => r.data);

export const changePassword = (payloadOrCurrentPassword, maybeNewPassword) => {
  const payload =
    typeof payloadOrCurrentPassword === "object"
      ? payloadOrCurrentPassword
      : {
          current_password: payloadOrCurrentPassword,
          new_password: maybeNewPassword,
        };

  return api.patch("/auth/me/password", payload).then((r) => r.data);
};


export const updateMe = (payload) =>
  api.patch("/auth/me", payload).then((r) => r.data);

export const updateMyContact = (payload) =>
  api.patch("/auth/me/contact", payload).then((r) => r.data);

export const verifyEmail = (token) =>
  api
    .get(`/auth/verify-email/${token}`)
    .then((response) => response.data);
